import React from "react";
import usePuestosLogic from "./hooks/usePuestosLogic";
import PuestosView from "./pages/PuestosView";

export default function Puestos() {
  const logic = usePuestosLogic();
  return <PuestosView {...logic} />;
}
